import { MODEL_NAMES } from '../constants/index';
import MessagingBase from './messaging-base';

export default class MessagingMessage extends MessagingBase {
  buildURL(modelName, id, snapshot, requestType, query) {
    let conversationId = id;
    if (query?.conversationId) {
      conversationId = query.conversationId;
      delete query.conversationId;
    } else if (snapshot) {
      conversationId = snapshot.belongsTo('conversation').id;
    }
    return `${this.host}/conversations/${conversationId}/messages`;
  }

  async softDelete(store, id) {
    const url = `${this.host}/messages/${id}`;
    const response = await fetch(url, {
      method: 'DELETE',
      headers: this.headers,
    });

    const data = await response.json();
    store.pushPayload(MODEL_NAMES.MESSAGE, data);
    return store.peekRecord(MODEL_NAMES.MESSAGE, id);
  }
}
